<template>
  <div
    class="global-modal-overlay"
    @click.self="handleOverlayClick"
  >
    <div
      class="global-modal-box"
      ref="modal"
      @mousedown="startedInside = true"
      @touchstart="startedInside = true"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      startedInside: false
    }
  },
  methods: {
    handleOverlayClick (e) {
      // dacă click-ul a început în interior, nu închidem
      if (this.startedInside) {
        this.startedInside = false
        return
      }
      // altfel, emitem evenimentul close
      this.$emit('close', e)
    }
  }
}
</script>

<style scoped>
.global-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  justify-content: end;
  align-items: center;
}

.global-modal-box {
  background: #fff;
  padding: 24px;
  width: calc(100% - 240px);
  max-width: calc(100% - 240px);
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-mini .global-modal-box {
  width: calc(100% - 120px);
  max-width: calc(100% - 120px);
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/GlobalModal.vue